export default __webpack_public_path__ + "static/media/toy-bricks-table-with-word-my-blog.4e160654.jpg";